export function tryParse(data: any) {
    try {
        return typeof data === 'string' ? JSON.parse(data) : data;
    } catch {
        return data;
    }
}
